<kilowant-header title="Clients"></kilowant-header>
<div class="wrapperMain mainAccountDetailsMain accountDetails">
    <div class="form buyer">
        <div class="mt-10 d-flex mb-10">
            <select name="viewClientsType" class="grey-select f14" [(ngModel)]="viewClientsType" (change)="changeClientView()">
                <option value="all">All</option>
                <option value="residential">Residential</option>
                <option value="commercial">Commercial</option>
            </select>
            <select name="viewActiveType" class="grey-select f14 ml-10" [(ngModel)]="viewActiveType" (change)="changeClientView()">
                <option value="all">All</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
            </select>
        </div>
        <input type="text" name="keywords" placeholder="SEARCH" class="search-clients" [(ngModel)]="keywords" (ngModelChange)="searchSiteInputChanged($event)" (keydown)="searchSiteInputChanged($event)" />
        <div>
            <table mat-table matSort [dataSource]="clients" matSortActive="ClientName" matSortDisableClear="true"
                   matSortDirection="asc" class="offer-summmary-table in-card-table background-transparent" multiTemplateDataRows>
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef class="text-center">&nbsp;&nbsp;</th>
                    <td mat-cell *matCellDef="let element; let rowIdx = dataIndex;" class="text-center">
                        {{currentStart+rowIdx+1}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="ClientName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                    <td mat-cell *matCellDef="let element" class="cursor-pointer long-text-cut">
                        {{element.clientName}}
                    </td>
                    <ng-container matColumnDef="expandedDetail">
                        <td mat-cell *matCellDef="let element" class="no-border" [attr.colspan]="displayedColumns.length">
                            <div>
                                @if (client!=null && (element.clientId === client.id)) {
                                <div class="card">
                                    <input type="text" name="clientName" placeholder="Client Name" [(ngModel)]="client.alias" (input)="resetError('ClientName')" [class]="getClassesForInput('ClientName', true, client.alias)" />
                                    @if (getVisibilityForLabel(client.alias)) {
                                    <div class="placeholder">Client Name</div>
                                    }
                                    <select class="placeholder" [(ngModel)]="clientType" (change)="switchClientType()">
                                        <option [selected]="(clientType=='Residential')">Residential</option>
                                        <option [selected]="(clientType=='Commercial')">Commercial</option>
                                    </select>
                                    <div class="placeholder">Client Class</div>
                                    @if (clientType=='Commercial') {
                                    <input name="company" [(ngModel)]="client.company!.name" (input)="resetError('FederalTaxID')" [class]="getClassesForInput('CompanyName', true, client.company!.name)" placeholder="Company" />
                                    @if (getVisibilityForLabel(client.company!.name)) {
                                    <div class="placeholder">Company</div>
                                    }
                                    }
                                    <input type="text"
                                           name="addressLine1"
                                           [class]="getClassesForInput('addressLine1', true, client.addressLine1)"
                                           (input)="resetError('addressLine1')"
                                           placeholder="Address Line 1"
                                           [(ngModel)]="client.addressLine1"
                                           [minlength]="validationService.getMinLength('User', 'address')"
                                           [maxlength]="validationService.getMaxLength('User', 'address')" />
                                    @if (getVisibilityForLabel(client.addressLine1)) {
                                    <div class="placeholder">Address Line 1</div>
                                    }
                                    <input type="text"
                                           name="addressLine2"
                                           [class]="getClassesForInput('addressLine2', true, client.addressLine2)"
                                           (input)="resetError('addressLine2')"
                                           placeholder="Address Line 2"
                                           [(ngModel)]="client.addressLine2"
                                           [minlength]="0"
                                           [maxlength]="validationService.getMaxLength('User', 'address')" />
                                    @if (getVisibilityForLabel(client.addressLine2)) {
                                    <div class="placeholder">Address Line 2</div>
                                    }
                                    <div class="cols">
                                        <div class="col auto">
                                            <input type="text" name="City" [value]="client.city" [disabled]="true" class="placeholder" />
                                            <div class="placeholder">City</div>
                                        </div>
                                        <div class="col">
                                            <input type="text" name="State" style="width: 60px;" [value]="getStateName(client.state)" [disabled]="true" class="placeholder" />
                                            <div class="placeholder">State</div>
                                        </div>
                                        <div class="col">
                                            <input type="text"
                                                   name="address"
                                                   [class]="getClassesForInput('zip', true, client.zip)"
                                                   style="width: 70px"
                                                   (input)="zipChanged()"
                                                   placeholder="Zip"
                                                   [(ngModel)]="client.zip"
                                                   [minlength]="validationService.getMinLength('User', 'zip')"
                                                   [maxlength]="validationService.getMaxLength('User', 'zip')" />
                                            @if (getVisibilityForLabel(client.zip)) {
                                            <div class="placeholder">Zip</div>
                                            }
                                        </div>
                                    </div>
                                    <div style="background-color: #EEE; padding: 10px; border-radius: 4px;" class="mb-10">
                                        <div class="mt-10">
                                            <select name="kilowantAccess" class="placeholder" [(ngModel)]="kilowantAccess" (change)="changeClientContact()">
                                                <option value="1">Client contact</option>
                                                <option value="2">Client manager contact</option>
                                            </select>
                                        </div>
                                        <div class="placeholder">Contact Class</div>

                                        @if (kilowantAccess==2) {
                                        <select class="placeholder" [compareWith]="compareKeyFn" [(ngModel)]="externalContact" (change)="changeExternalContact()">
                                            <optgroup label="Existing Manager Contacts">
                                                @for (contactManager of contactManagers; track contactManager) {
                                                <option [ngValue]="contactManager">{{contactManager.value}}</option>
                                                }
                                            </optgroup>
                                            <optgroup label="Add a new Manager Contacts">
                                                <option [ngValue]="null">Add</option>
                                            </optgroup>
                                        </select>
                                        <div class="placeholder">Manager Contact</div>
                                        }

                                        @if ((kilowantAccess==1 || kilowantAccess==2) && editContact!=null) {
                                        <div class="table-view">
                                            <div class="row">
                                                <div class="cell">
                                                    <input type="text" name="FirstName" [disabled]="clientEditDisabled()" [class]="getClassesForInput('FirstName', true, editContact.firstName)" (input)="resetError('FirstName')" placeholder="First name" [(ngModel)]="editContact.firstName" [minlength]="validationService.getMinLength('User', 'firstName')" [maxlength]="validationService.getMaxLength('User', 'firstName')" />
                                                    @if (getVisibilityForLabel(editContact.firstName)) {
                                                    <div class="placeholder">First name</div>
                                                    }
                                                </div>
                                                <div class="cell">
                                                    <input type="text" name="LastName" [disabled]="clientEditDisabled()" [class]="getClassesForInput('LastName', true, editContact.lastName)" (input)="resetError('LastName')" placeholder="Last name" [(ngModel)]="editContact.lastName" [minlength]="validationService.getMinLength('User', 'lastName')" [maxlength]="validationService.getMaxLength('User', 'lastName')" />
                                                    @if (getVisibilityForLabel(editContact.lastName)) {
                                                    <div class="placeholder">Last name</div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <input type="text" name="Email" class="w-100" [disabled]="clientEditDisabled()" [class]="getClassesForInput('Email', true, editContact.email)" (input)="resetError('Email')" [(ngModel)]="editContact.email" placeholder="Email" />
                                        @if (getVisibilityForLabel(editContact.email)) {
                                        <div class="placeholder">Email</div>
                                        }
                                        <input type="text" name="Phone"
                                               [disabled]="clientEditDisabled()"
                                               [class]="getClassesForInput('Phone', true, (((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+((focusedField()=='Phone')?'1':'')))"
                                               (input)="resetError('Phone')"
                                               placeholder="Mobile Phone"
                                               [dropSpecialCharacters]="false"
                                               [formControl]="currentPhoneNumber"
                                               (focus)="focusField('Phone')"
                                               mask="(000) 000-0000"
                                               [showMaskTyped]="(focusedField()=='Phone')||(currentPhoneNumber.value!=null && currentPhoneNumber.value?.trim()!='' && !currentPhoneNumber.value.valid)" />
                                        @if (getVisibilityForLabel(((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+((focusedField()=='Phone')?'phone':''))) {
                                        <div class="placeholder">Mobile Phone</div>
                                        }
                                        }
                                        <div style="text-align: right; margin-top: -10px; font-size: 13px;">
                                            @if (clientEditDisabled()) {
                                            <a (click)="addUpdateContactManager()" class="link">Update</a>
                                            }
                                        </div>
                                    </div>

                                    @if (clientType=='Commercial' && client!.company!=null) {
                                    <div>
                                        <div class="mb-10 mt-10">
                                            <label>
                                                <input type="checkbox" name="taxExempt" [(ngModel)]="client!.company!.taxExempt" /> Client is Tax Exempt?
                                            </label>
                                        </div>
                                        @if (client!.company!.taxExempt) {
                                        <div>
                                            <input type="text" name="FederalTaxID" class="w-100"
                                                   [class]="getClassesForInput('FederalTaxID', true, client!.company!.federalTaxID)" value=""
                                                   (input)="resetError('FederalTaxID')" [(ngModel)]="client!.company!.federalTaxID"
                                                   placeholder="Federal Tax ID" />
                                            @if (getVisibilityForLabel(client!.company!.federalTaxID)) {
                                            <div class="placeholder">Federal Tax ID</div>
                                            }
                                            <div class="mt-20"> Please upload a photo or a copy of your tax exempt certificate.</div>
                                            @if ((fileToUpload==null) && client!.company!.taxExemptCertificateDocument==null) {
                                            <label class="formLabel"
                                                   [class]="(errorY().isWrong('fileToUpload'))?'error':''">
                                                CHOOSE FILES
                                                <span>no files selected</span>
                                                <input type="file" name="taxExemptCertificateDocument" class="required" value=""
                                                       placeholder="Tax Exempt Certificate Document" (change)="handleFileInput($event)" />
                                            </label>
                                            }
                                            @if (fileToUpload!=null || client!.company!.taxExemptCertificateDocument!=null) {
                                            <div class="files-list">
                                                <span>File selected</span>
                                                <ul>
                                                    @if (client!.company!.taxExemptCertificateDocument!=null) {
                                                    <li>
                                                        <a (click)="deleteExistingFile(client!.company!.taxExemptCertificateDocument.key)"></a>
                                                        <div class="link" (click)="downloadFile(true, client!.company!.taxExemptCertificateDocument.key)">{{client!.company!.taxExemptCertificateDocument.value}}</div>
                                                    </li>
                                                    }
                                                    @if (fileToUpload!=null) {
                                                    <li>
                                                        <a (click)="deleteFile()"></a>
                                                        <div class="link" (click)="downloadFile(false, null)">{{fileToUpload.name}}</div>
                                                    </li>
                                                    }
                                                </ul>
                                            </div>
                                            }
                                        </div>
                                        }
                                    </div>
                                    }

                                    <label><input type="checkbox" name="active" [(ngModel)]="client.isActive" [checked]="client.isActive" /> Client is Active</label>


                                    @if (this.errorY().showError()) {
                                    <div class="error-block">{{this.errorY().error}}</div>
                                    }

                                    @if (kilowantAccess==1 && client.email!=null && client.email.length>0) {
                                    <div class="block-buttons full-width small mt-20">
                                        <button class="mt-10" (click)="setClientSelfManaged(this.client)" type="button">Switch to Self-Managed</button>
                                    </div>
                                    }

                                    <div class="block-buttons full-width small mt-20">
                                        <button type="button" (click)="cancel()">Cancel</button>
                                        <button type="button" (click)="updateClient()">Update</button>
                                        <button type="button" [disabled]="element.hasActivity" (click)="deleteClient(client)">Delete</button>
                                    </div>
                                </div>
                                }
                            </div>
                        </td>
                    </ng-container>
                </ng-container>
                <ng-container matColumnDef="AccountCount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Accts </th>
                    <td mat-cell *matCellDef="let element" class="cursor-pointer long-text-cut">
                        {{element.numberAccounts}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="NextAvailableDate">
                    <th mat-header-cell *matHeaderCellDef> Exp </th>
                    <td mat-cell *matCellDef="let element" class="cursor-pointer long-text-cut">
                        {{element.nextAvailableDate | date:'shortDate'}}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let element; let row; columns: displayedColumns;" (click)="editClient(element.clientId)" [class]="((this.client!=null && (element.clientId==this.client.id))?'selected':'') + ((element.isActive)?'':' inactive')"></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="b-none"></tr>
            </table>
            <mat-paginator [length]="total" hidePageSize="true" [pageSize]="RECS_PER_PAGE" aria-label="Select page"></mat-paginator>
        </div>
    </div>
    <div class="block-buttons mt-10 under-card full-width">
        <button type="button" (click)="downloadReport()">Download Report</button>
        <button type="button" (click)="addClient()">Add Client</button>
    </div>
</div>